module.exports = __webpack_public_path__ + "img/immuTest2.97ac31c8.png";